import { pageSelectorGenerator } from '@test/pageSelectors';

export const GiftMetadataSelectors = pageSelectorGenerator('GiftMetadata', ['TitleText', 'GiftAmountText']);
